module.exports = "/packs/ipad-landscape-15441b18cc32f4867267a4bf16a7bba9.png";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/packs/Shared/assets/images/ipad-landscape.png
// module id = ./app/javascript/packs/Shared/assets/images/ipad-landscape.png
// module chunks = 1